module.exports = __webpack_public_path__ + "27.gif?52244f167cc2d446131c0c67f0daa0a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/27.gif
// module id = 51
// module chunks = 0